import { routes } from './routes';
import GasOrdemIntervencao from './ordensintervencao';
import GasProcessos from './processos';
import GasClientes from './clientes';
import GasRelatorios from './relatorios';
import GasAgendamentos from './agendamentos';
import GasDistribuidores from './distribuidores';
import GasOrds from './ords';
import GasCalendarizacaoController from './calendarizacao/controller';
import GasService from "./gas.service.ts";
export default angular.module('app.gas', [GasOrdemIntervencao, GasProcessos, GasClientes, GasRelatorios, GasAgendamentos, GasDistribuidores, GasOrds])
    .config(routes)
    .controller('GasCalendarizacaoController', GasCalendarizacaoController)
    .service("GasService", GasService)
    .name;
